<template>
  <div class="sso-entry-container">
    <div class="sso-entry-card">
      <div class="spinner-border text-primary" role="status" aria-label="連携処理中" />
      <p class="sso-entry-message">{{ statusMessage }}</p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { consumeSystemHandoff } from '@/api/axios';

export default {
  name: 'SsoEntryPage',
  setup() {
    const title = ref('システム連携中');
    const statusMessage = ref('システム連携中です...');
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const resolveSsoErrorMessage = (error) => {
      const apiData = error?.response?.data;
      const firstError = Array.isArray(apiData?.errors) ? apiData.errors[0] : null;

      if (firstError) return firstError;
      if (typeof apiData?.error === 'string') return apiData.error;
      if (typeof apiData?.message === 'string') return apiData.message;

      return 'システム連携ログインに失敗しました。通常ログインしてください。';
    };

    const completeLoginSession = () => {
      store.commit('setLoggedIn', true);
      store.commit('setUserName', localStorage.getItem('userName'));
      store.commit('setUserRole', localStorage.getItem('userRole'));
    };

    const redirectToLoginWithError = (message) => {
      store.commit('setFlashMessage', { message, type: 'danger' });
      router.replace('/login');
    };

    onMounted(async () => {
      const handoffToken = route.query.sso_token;
      if (typeof handoffToken !== 'string' || handoffToken.length === 0) {
        redirectToLoginWithError('システム連携トークンが見つかりません。通常ログインしてください。');
        return;
      }

      try {
        await consumeSystemHandoff(handoffToken);
        completeLoginSession();
        router.replace('/home');
      } catch (error) {
        const errorMessage = resolveSsoErrorMessage(error);
        redirectToLoginWithError(errorMessage);
      }
    });

    return {
      statusMessage
    };
  }
};
</script>

<style scoped>
.sso-entry-container {
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.sso-entry-card {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.sso-entry-message {
  margin: 0;
  font-size: 14px;
  color: #1f2d3d;
}
</style>
